import { Box, Button, Flex, Text } from "@chakra-ui/react";
import { Modal, Select } from "antd";
import React from "react";

// Claude: extracted from Buyer.tsx 23-03-2026
interface Props {
  isOpen: boolean;
  onClose: () => void;
  industryNodes: any[];
  assignIndustryIds: string[];
  setAssignIndustryIds: (ids: string[]) => void;
  onAssign: () => void;
}

const BuyerAssignIndustryModal = ({
  isOpen, onClose, industryNodes, assignIndustryIds, setAssignIndustryIds, onAssign,
}: Props) => (
  <Modal title="Assign Industry" footer={null} open={isOpen} onCancel={onClose}>
    <Box p={2}>
      <Text mb={3} fontSize="sm">Select one or more industries to assign to the selected buyers:</Text>
      <Select
        mode="multiple"
        showSearch
        optionFilterProp="label"
        style={{ width: "100%" }}
        placeholder="Select industries"
        value={assignIndustryIds}
        onChange={(vals: string[]) => setAssignIndustryIds(vals)}
        options={industryNodes
          .filter((n: any) => !n.parentId)
          .map((n: any) => ({ label: n.name, value: n._id }))}
      />
      <Flex justifyContent="flex-end" mt={4}>
        <Button background="#0E122F" color="white" px={4} py={2} h="auto"
          _hover={{ background: "#2E7D32" }} onClick={onAssign}
        >
          Assign
        </Button>
      </Flex>
    </Box>
  </Modal>
);

export default BuyerAssignIndustryModal;
